export function permitDetailHref(sourceId: string, permitId: string): string {
  return `/permit-detail?permitId=${encodeURIComponent(permitId)}&sourceId=${encodeURIComponent(sourceId)}`;
}
